// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-y-enter,.modal-y-leave-to{transform:translateY(-1000px)}.modal-y-enter-active,.modal-y-leave-active{transition:all .3s ease}", ""]);
// Exports
module.exports = exports;
